import { createContext, useContext } from 'react';
import { useController } from 'react-hook-form';

export type ControlledFieldContextValue = {
  name: string;
  defaultValue?: unknown;
};

export const ControlledFieldContext = createContext<ControlledFieldContextValue | null>(null);

export const useControlledField = () => {
  const context = useContext(ControlledFieldContext);

  if (!context) {
    throw new Error('useControlledField must be used within a ControlledField');
  }

  return useController(context);
};
